<template>
  <div class="deail-page-container" v-loading="loading">
    <el-card class="box-card searchBar" shadow="never">
      <el-radio-group v-model="activeStatus" @change="typeChange">
        <el-radio-button :label="10" >进行中</el-radio-button>
        <el-radio-button :label="20">已结束</el-radio-button>
      </el-radio-group>
      <div class="time">
        数据更新时间：{{updateTime? (updateTime.beginDate || '--') + ' 至 ' + (updateTime.endDate || '--') : '--'}}
        <download-button v-if="![11, 12].includes(activeType)" :downloadApi="exportActivityData" :queryParams="baseData"></download-button>
      </div>
    </el-card>
    <template v-if="haveActive">
      <el-card class="box-card serch-card" shadow="never">
        <el-form :inline="true" label-position="right"  label-width="90px" :model="form" ref='time' class="time-form">
          <el-form-item label="活动名称">
            <el-cascader
              style="width: 224px"
              v-model="form.activeName"
              :props="activeNameProps"
              :options="nameOptions"
              :show-all-levels="false"
              @change="nameChange"
              @expand-change="expandChange"
              >
            </el-cascader>
            <el-button class="getDetail" :disabled="!this.activeId" @click="detailView(activeId)">查看详情</el-button>
          </el-form-item>
          <el-form-item label="统计时间">
            <el-radio-group v-model="form.time" @change="timeTypeChange" v-if="activeStatus === 10 && activeType !== 12">
              <el-radio-button v-for="item in timeOption" :key="item.code" :label="item.code">{{item.desc}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              class="date-picker"
              v-model="form.dataTime" 
              type="daterange"
              value-format="yyyy-MM-dd" 
              range-separator="-"   
              start-placeholder="开始时间" 
              end-placeholder="结束时间" 
              @change="formTimeChange" 
              :picker-options="{disabledDate}"
              :editable="false">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-card>
      <template v-if="activeInfo">
        <!-- 步骤条 -->
        <Steps ref="steps" v-if="showActiveData" :expressNumber="activeInfo.expressNumber"></Steps>
        <!-- 活动概览 -->
        <OverviewMod :baseData="baseData" ref="overview" v-if="showOverviewMod"></OverviewMod>
        <!-- 活动冲单活动数据 -->
        <RunAchieveMod :activeInfo="activeInfo" ref="runAchieveOverview" v-if="showRunAchieve" />
        <!-- 活动趋势 -->
        <ActiveTrend :baseData="baseData" ref="activeTrend" v-if="showActiveTrend"></ActiveTrend>
        <!-- 活动效果 -->
        <ActiveResult :baseData="baseData" ref="activeResult" v-if="showActiveResult"></ActiveResult>
        <!-- 抽奖宝活动数据 -->
        <ActiveData :baseData="baseData" ref="activeData" v-if="showActiveData"></ActiveData>
        <!-- 活动冲单 -->
        <RunAchieve :activeInfo="activeInfo" ref="runAchieve" v-if="showRunAchieve" />
        <div class="bottom-box">
          <!-- 近30天同类 -->
          <SimilarActive :baseData="baseData" ref="similarActive" @openDetail='detailView' v-if="showSimilarActive"></SimilarActive>
          <!-- 用户贡献对比 -->
          <UserContribute :baseData="baseData" ref="userContribute" v-if="showUserContribute"></UserContribute>
        </div>
      </template>
      <el-card v-else shadow="never">
        <NoData errTitle="暂无数据" setHeight="500px"></NoData>
      </el-card>
      <el-drawer
        :visible.sync="showDetail"
        :with-header="false"
        size="40%"
      >
        <p class="detatl-title"> <i class="el-icon-s-fold"></i> 活动详情</p>
        <!-- 天天特价 -->
        <special-price :id="getDetailId" :show="showDetail" :detailType="activeType" v-if="activeType === 7" />

        <!-- 加油送箱水 -->
        <send-water :id="getDetailId" :show="showDetail" :detailType="activeType" :activeStatus="activeStatus" :showButton="false" v-if="activeType === 8" />

        <!-- 限时秒杀 -->
        <limitShop :id="getDetailId" :show="showDetail" :detailType="activeType" v-if="activeType === 9" />
      
        <!-- 抽奖宝 -->
        <luckDraw :id="getDetailId" :show="showDetail" :detailType="activeType" v-if="activeType === 11" :activeStatus="activeStatus" :showButton="false" />

        <!-- 活动冲单 -->
        <runAchieveDetail :id="getDetailId" :show="showDetail" v-if="activeType === 12"/>
      </el-drawer>
    </template>
    <el-card v-else shadow="never" class="nodata">
      <NoData errTitle="" setHeight="700px">
        <p class="title">{{activeStatus===10? '暂无进行中的活动，':'暂无已结束的活动'}}<span v-show="activeStatus===10" class="signup" @click="$router.push({path:'/promotion/centerShow'})">去报名</span></p>
      </NoData>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { selectOption } from './config'
import * as echartList from './components/echartList'
import specialPrice from '../../marketShop/components/marketList/specialPrice'
import sendWater from '../../marketShop/components/marketList/sendWater'
import limitShop from '../../marketShop/components/marketList/limitShop'
import luckDraw from '../../marketShop/components/marketList/luckDraw'
import runAchieveDetail from '../../marketShop/components/marketList/runAchieve'
import RunAchieveMod from './components/runAchieveMod'
import NoData from "@/components/base/no-data"
import { getActiveList, getActiveDetail, getWaterActiveDetail, getActiveSort, getUpdateTime, getActiveData, exportActivityData } from "@/api/marketPromotion/activeData";
import { drawDetail } from '@/api/marketShop'
import { getActivityTypeList } from '@/api/marketPromotion'
import { getOverview } from "@/api/runAchieve/signUp"
import dayjs from 'dayjs'

// 埋点
let mdObj = {
  pageview: {
    type: 'pageViewEvent',
    name: '营销推广-营销数据',
    id: '1627641850'
  },
  changeActiveName: {
    type: 'clickEvent',
    name: '营销推广-营销数据-活动名称',
    id: '1627641852'
  },
  getDetail: {
    type: 'clickEvent',
    name: '营销推广-营销数据-查看详情',
    id: '1627641853'
  },
  changeTime: {
    type: 'clickEvent',
    name: '营销推广-营销数据',
    id: '1627641854'
  },
}
export default {
  components: { ...echartList, NoData, specialPrice, sendWater, limitShop, luckDraw, runAchieveDetail, RunAchieveMod },
  data () {
    return {
      exportActivityData,
      loading: true,
      haveActive: false,
      activeId: '',
      getDetailId: '',
      gasId: '',
      // activeType: 1,
      activeType: 10,
      activeInfo: null,
      updateTime: null,
      ...selectOption,
      showDetail:false,
      activeStatus: 10,
      nameOptions: [],
      activeNameProps: {
        label: 'activeName',
        value: 'id'
      },
      form: {
        activeName: [],
        status: '',
        time: 1,
        dataTime: []
      },
      detail: {
        7: getActiveDetail,
        8: getWaterActiveDetail,
        9: getActiveDetail,
        11: drawDetail,
        12: getOverview
      }
    } 
  },
  mounted () {
    this.maidian(mdObj.pageview)
    this.activeId = Number(this.$route.query.activeId)
    this.activeType = Number(this.$route.query.activeType)
    this.activeStatus = Number(this.$route.query.gasStatus) || 10
    this.form.time = this.defaultTime
    this.gasId = this.$route.query.gasId || this.userInfo.gasId
    if (this.activeId) {
      // 从活动列表进入
      this.form.activeName = [this.activeType, this.activeId]
      let params = {
        activeStatusClassify: this.activeStatus,
        activeType: this.activeType,
        gasId: this.gasId,
        pageIndex: 1,
        pageSize: 100
      }
      this.getActivityTypeList().then(() => this.getActiveList(params))
      this.getActiveDetail(this.activeId)
    } else {
      // 从菜单进入 默认显示最新活动
      this.getActivityTypeList().then(() => this.getActiveByDate())
    }
  },
  provide () {
    return {
      resetData: () => {
        let params = {
          activeStatusClassify: this.activeStatus,
          activeType: this.activeType,
          gasId: this.gasId,
          pageIndex: 1,
          pageSize: 100
        }
        this.getActiveList(params)
        this.getActiveDetail(this.activeId)
      },
      getListData: null
    }
  },
  methods: {
    // 埋点
    maidian (obj) {
      const { type, name, id, other = {} } = obj
      this.$track[type](name, id, other)
    },
    disabledDate(time) {
      if(!this.activeInfo) return false
      let startTime = time.getTime() < new Date(this.activeInfo.startTime).getTime()
      let endTime = time.getTime() > Date.now() - 8.64e7 || time.getTime() > new Date(this.activeInfo.endTime).getTime()
      return startTime || endTime
    },
    // 进行中 已结束
    typeChange () {
      this.loading = true
      this.form.time = this.defaultTime
      this.form.dataTime = []
      this.activeInfo = null
      this.form.activeName = []
      this.getActivityTypeList()
      this.getActiveByDate()
      this.updateTime = null
    },
    // 默认显示最新活动
    getActiveByDate() {
      let params = {
        gasId: this.gasId,
        activeStatusClassify: this.activeStatus,
        pageSize: 100,
        pageIndex: 1,
      }
      this.haveActive = false
      this.getActiveSort(params)
    },
    // 时间区间改变
    timeTypeChange (val) {
      let tysj_date_type
      switch (val) {
        case 0:
          tysj_date_type = 1
          break;
        case 1:
          tysj_date_type = 2
          break;
        case -1:
          tysj_date_type = 3
          break;
        case 7:
          tysj_date_type = 4
          break;
        case 30:
          tysj_date_type = 5
          break;
        default:
          tysj_date_type = 6
          break;
      }
      mdObj.changeTime.other = { tysj_date_type }
      this.maidian(mdObj.changeTime)
      this.form.dataTime = []
      this.updateData()
      this.getUpdateTime()
    },
    formTimeChange () {
      if (this.form.dataTime && this.form.dataTime.length) {
        this.form.time = 2
      } else {
        this.form.time = this.defaultTime
      }
      if(this.form.dataTime) {
        mdObj.changeTime.other = {
          tysj_start_time: this.form.dataTime[0],
          tysj_end_time: this.form.dataTime[1],
          tysj_date_type: 6
        }
        this.maidian(mdObj.changeTime)
      }
      this.updateData()
      this.getUpdateTime()
    },
    // 查询活动名称
    expandChange (val) {
      let params = {
        activeStatusClassify: this.activeStatus,
        activeType: val[0],
        gasId: this.gasId,
        pageIndex: 1,
        pageSize: 100
      }
      this.getActiveList(params)
    },
    // 活动名称改变 
    nameChange () {
      mdObj.changeActiveName.other = {tysj_trade_type: this.form.activeName[0]}
      this.maidian(mdObj.changeActiveName)
      this.activeInfo = null
      this.activeType = this.form.activeName[0]
      this.activeId = this.form.activeName[1]
      this.form.time = this.defaultTime
      this.form.dataTime = []
      this.updateTime = null
      this.getActiveDetail(this.form.activeName[1])
    },
    // 右侧详情弹窗
    detailView (id) {
      this.getDetailId = id
      this.showDetail = true
      this.maidian(mdObj.getDetail)
    },
    // 刷新页面数据
    updateData () {
      this.$nextTick(async () => {
        if (this.showOverviewMod) this.$refs.overview.init()
        if (this.showActiveTrend) this.$refs.activeTrend.init()
        if (this.showActiveResult) this.$refs.activeResult.init()
        if (this.showSimilarActive) this.$refs.similarActive.init()
        if (this.showUserContribute) this.$refs.userContribute.init()
        if (this.showRunAchieve) {
          await this.getRunAchieveData()
          this.$refs.runAchieve.init()
          this.$refs.runAchieveOverview.init()
        }
        if (this.showActiveData) {
          this.getActiveData(this.baseData)
        }
      })
    },
    async getActivityTypeList () {
      try {
        const { result, code } = await getActivityTypeList()
        if(code !== 200) return
        this.nameOptions = []
        result.forEach(item => {
          this.nameOptions.push({ id: item.key, activeName: item.value, children:[] })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getActiveList (params) {
      const { result } = await getActiveList(params)
      const childArr = result || []
      for(let i = 0; i<this.nameOptions.length;i++){
        if(this.nameOptions[i].id === params.activeType){
          this.$nextTick(() => {
            this.$set(this.nameOptions[i], 'children', childArr)
          })
          break;
        }
      }
    },
    // 活动详情
    async getActiveDetail (activeId) {
      this.loading = true
      try {
        // drawDetail
        let param = this.activeType === 8 ? { activityId: activeId } : { activeId }
        const { code, result } = await this.detail[this.activeType](param)
        if (code !== 200) return
        // 送水活动
        if(this.activeType === 8) {
          this.activeInfo = result
          this.activeInfo.startTime = this.activeInfo.beginTime
          this.activeInfo.endTime = this.activeInfo.offlineTime ? this.activeInfo.offlineTime : this.activeInfo.endTime
        } else if (this.activeType === 11) {
          this.activeInfo = result
          this.activeInfo.startTime = this.activeInfo.beginTime
        } else if (this.activeType === 12) {
          this.activeInfo = result
          this.activeInfo.startTime = dayjs(result.startDate).format('YYYY-MM-DD 00:00:00')
          this.activeInfo.endTime = dayjs(result.endDate).format('YYYY-MM-DD 23:59:59')
          this.form.dataTime = [result.startDate, result.endDate]
        } else {
          this.activeInfo = result.isNewTable ? result.activeInfoNewResponse : result.activeInfoResponse
        }
        this.getUpdateTime()
        this.form.time = this.defaultTime
        this.$nextTick(() => this.updateData())
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.haveActive = true
      }
    },
    // 查询最新活动
    async getActiveSort (param) {
      try {
        const { code, result } = await getActiveSort(param)
        if (code !== 200 || !result.id) {
          this.loading = false
          return
        }
        this.activeId = result.id
        this.activeType = result.activeType
        this.form.activeName = [this.activeType, this.activeId]
        let data = {
          activeStatusClassify: this.activeStatus,
          activeType: this.activeType,
          gasId: this.gasId,
          pageIndex: 1,
          pageSize: 100
        }
        this.getActiveList(data)
        this.getActiveDetail(this.activeId)
      } catch (error) {
        console.log(error)
      }
    },
    // 获取数据更新时间
    async getUpdateTime () {
      try {
        const { code, result } = await getUpdateTime(this.baseData)
        if (code !== 200) return
        this.updateTime = result
      } catch (error) {
        console.log(error)
      }
    },
    // 获取抽奖宝数据
    async getActiveData (param) {
      try {
        const { code, result } = await getActiveData({ ...param, trendTarget:'1', applyId: this.activeInfo.id })
        if (code !== 200) return
        this.$refs.steps.init(result)
        this.$refs.activeData.init(result)
      } catch (error) {
        console.log(error)
      }
    },
    // 获取活动冲单数据
    async getRunAchieveData () {
      let params = {
        activeId: this.activeId,
        startDate: this.form.dataTime && this.form.dataTime[0],
        endDate: this.form.dataTime && this.form.dataTime[1]
      }
      const { code, result } = await getOverview(params)
      if (code !== 200) return
      this.activeInfo = result
      this.activeInfo.startTime = dayjs(result.startDate).format('YYYY-MM-DD 00:00:00')
      this.activeInfo.endTime = dayjs(result.endDate).format('YYYY-MM-DD 23:59:59')
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    baseData () {
      const { activeType } = this
      let newType
      if (activeType === 7) newType = 1
      if (activeType === 8) newType = 2
      if (activeType === 9) newType = 3
      if (activeType === 11) newType = 4
      if (activeType === 12) newType = 5
      let params = {
        activityType: newType,
        gasId: this.gasId,
        dataType: this.form.time === 2 ? 0 : this.form.time,
        activityBeginTime: this.activeInfo?.startTime || 0,
        activityEndTime: this.activeInfo?.endTime || 0,
        timeType: this.form.time
      }
      if (this.form.time === 2) {
        params.beginDate = this.form.dataTime[0]
        params.endDate = this.form.dataTime[1]
      } else if (this.form.time === 0) {
        params.beginDate = this.activeInfo?.startTime.split(' ')[0]
        params.endDate = this.activeInfo?.endTime.split(' ')[0]
      }
      return params
    },
    defaultTime () {
      return this.activeStatus === 20 || this.activeType === 11 ? 0 : 1
    },
    showOverviewMod () {
      return [7, 8, 9].includes(this.activeType)
    },
    showActiveTrend () {
      return [7, 8, 9].includes(this.activeType)
    },
    showActiveResult () {
      return [9].includes(this.activeType) && this.form.time === 1
    },
    showSimilarActive () {
      return [7, 9].includes(this.activeType) && this.form.time === 0
    },
    showUserContribute () {
      return [7, 9].includes(this.activeType)
    },
    showActiveData () {
      return [11].includes(this.activeType)
    },
    showRunAchieve () {
      return [12].includes(this.activeType)
    }
  }
}
</script>
<style lang="less" scoped>
.el-card {
  border: none;
}
.deail-page-container {
  min-width: 80%;
  min-height: 850px;
  padding: 30px 10px;
  box-sizing: border-box;
  background-color: #F8F9FD;
  .searchBar {
    margin-bottom: 10px;
    .label {
      margin-left: 12px;
      color: #222222;
      font-size: 14px;
    }
    .time {
      float: right;
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      height: 40px;
      line-height: 40px;
    }
  }
  .serch-card {
    margin-bottom: 10px;
    /deep/.el-form-item{
      margin-bottom: 0;
      margin-right: 0;
    }
    .el-radio-group {
      margin-right: 20px;
    }
  }
  .back-btn {
    width: 120px;
    margin-bottom: 10px;
  }
  .title {
    font-size: 19px;
    margin-right: 5px;
  }
  .time {
    font-size: 14px;
  }
  .getDetail {
    margin-left: 8px;
    width: 100px;
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
  }
  .signup{
    color: #409eff;
    cursor: pointer;
  }
  /deep/.el-drawer {
    height: 100vh;
    min-width: 600px;
    overflow-y: auto;
    font-size: 14px;
    padding: 20px;
    p {
      margin: 0;
    }
    .detatl-title {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 700;
      color: #222222;
      // padding: 0 20px;
      border-bottom: 1px solid #F4F4F4;;
      margin-bottom: 25px;
    }
  }
  /deep/.serch-card .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #409EFF;
    background-color: #fff;
    border-color: #409EFF;
    box-shadow: -1px 0 0 0 #409eff;
  }
  /deep/.searchBar .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    background-color: #4B7EFE;
  }
}
</style>